import { Schema } from "effect";
import { R2Target, type R2Binding } from "../../api/r2/model.ts";

export const R2Action = Schema.Union([
  Schema.TaggedStruct("SelectWorkspace", { workspaceId: Schema.NullOr(Schema.String), refreshToken: Schema.optionalKey(Schema.Number) }),
  Schema.TaggedStruct("Refresh", {}),
  Schema.TaggedStruct("Upload", { target: R2Target }),
  Schema.TaggedStruct("Delete", { target: R2Target, key: Schema.String }),
  Schema.TaggedStruct("Download", { target: R2Target, key: Schema.String })
]);
export type R2Action = typeof R2Action.Type;
export const R2Settlement = Schema.Struct({ target: R2Target, operation: Schema.Literals(["upload", "delete"]), key: Schema.String, outcome: Schema.Literals(["success", "refused"]), progress: Schema.Literals(["uncertain", "complete"]), message: Schema.NullOr(Schema.String) });
export type R2Settlement = typeof R2Settlement.Type;
export interface R2Snapshot {
  readonly workspaceId: string | null;
  readonly bindings: readonly R2Binding[];
  readonly loading: boolean;
  readonly mutating: boolean;
  readonly error: string | null;
}
export const emptyR2 = (workspaceId: string | null = null, mutating = false): R2Snapshot => ({ workspaceId, bindings: [], loading: false, mutating, error: null });
